// Set cookies
var referralCode = Cookies.get('referralCode');
var voucherCode = Cookies.get('voucherCode');
var offerCode = Cookies.get('offerCode');
var acceptCookies = Cookies.get('acceptCookies');
var frequency = Cookies.get('deliveryfrequency');

var frequencyUrl = $.url('?deliveryfrequency');
if (frequencyUrl){
    frequency = frequencyUrl;
    Cookies.set('deliveryfrequency', frequency, { expires: 28 });
}

var voucherCodeUrl = $.url('?vc');
/*if (voucherCodeUrl){
    if (voucherCodeUrl != voucherCode) {
        Cookies.remove('vcPopup');
    }
    voucherCode = voucherCodeUrl;
    referralCode = null;
}*/

var referralCodeUrl = $.url('?ref');
if (referralCodeUrl){
    referralCode = referralCodeUrl;
    voucherCode = null;
}

if (referralCodeUrl == 'reset'){
   referralCode = null;
}

if (voucherCodeUrl == 'reset'){
    setVoucherCode('reset');
}

if (referralCode) {
    setVoucherCode('reset');
    Cookies.set('referralCode', referralCode, { expires: 28 });
} else {
    Cookies.remove('referralCode');
    Cookies.remove('refPopup');
}

if (voucherCode) {
//    setVoucherCode(voucherCode);
}

var offerCodeUrl = $.url('?offer');
if (offerCodeUrl){
    offerCode = offerCodeUrl;
}

if (offerCodeUrl == 'reset'){
   offerCode = null;
}

if (offerCode) {
    Cookies.set('offerCode', offerCode, { expires: 28 });
} else {
    Cookies.remove('offerCode');
}

function setVoucherCode(code) {
    if (code.toLowerCase() == 'reset') {
        Cookies.remove('voucherCode');
        Cookies.remove('vcPopup');
        voucherCode = null;
    } else {
        Cookies.set('voucherCode', code, { expires: 28 });
    }
}
